import type {
  ReplacementDeviceType,
  ReplacementStatus,
  ReplacementStatusFilter,
} from '../../lib/api/replacements';

/**
 * Every `t()` key this module needs for the closed vocabularies
 * `replacements.ts` carries — the identical shape `justificationLabels.ts`
 * and `escalationLabels.ts` document: `as const satisfies Record<...>` is
 * what keeps a template-literal key (`` t(`replacements.status.${x}`) ``)
 * out of this codebase. That form compiles but fails `npm run typecheck`
 * against the typed `t()` overloads `i18next.d.ts` installs, because
 * TypeScript widens the template to `string`, which is not a key
 * `en.json`'s shape admits. These objects are the one place each vocabulary
 * is mapped to a literal key.
 */

export const STATUS_LABEL_KEY = {
  requested: 'replacements.status.requested',
  dispensed: 'replacements.status.dispensed',
  rejected: 'replacements.status.rejected',
} as const satisfies Record<ReplacementStatus, string>;

/** The status-filter segmented control offers four values — `all` included, unlike `STATUS_LABEL_KEY` above, which types only a ROW's own status. */
export const QUEUE_LABEL_KEY = {
  requested: 'replacements.queue.requested',
  dispensed: 'replacements.queue.dispensed',
  rejected: 'replacements.queue.rejected',
  all: 'replacements.queue.all',
} as const satisfies Record<ReplacementStatusFilter, string>;

export const QUEUE_EMPTY_KEY = {
  requested: 'replacements.empty.requested',
  dispensed: 'replacements.empty.dispensed',
  rejected: 'replacements.empty.rejected',
  all: 'replacements.empty.all',
} as const satisfies Record<ReplacementStatusFilter, string>;

export const DEVICE_TYPE_LABEL_KEY = {
  sensor: 'replacements.deviceType.sensor',
  reader: 'replacements.deviceType.reader',
} as const satisfies Record<ReplacementDeviceType, string>;
